<template>
  <b-container fluid>
    <b-spinner
      v-if="isLoading"
      type="grow"
      class="text-center"
      style="margin-top: 10%; position:absolute;"
      variant="primary"
    ></b-spinner>

    <b-navbar toggleable="lg" type="dark" variant="light">
      <b-navbar-brand href="#" class="text-dark">
        <strong>Traning Courses</strong>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button
              variant="outline-info"
              size="sm"
              style="margin-right:30px;"
              @click="reloadTable"
            >
              <font-awesome-icon icon="sync" />
            </b-button>
            <b-button
              class="my-2 my-sm-0 mr-2"
              variant="outline-primary"
              size="sm"
              :to="addTrainingCoursePath"
            >
              <font-awesome-icon icon="plus" />
            </b-button>
            <b-form-group
              label-cols-sm="3"
              label-align-sm="right"
              label-size="sm"
              label-for="filterInput"
            >
              <b-input-group size="sm">
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-row>
      <b-col cols="12" class="mt-1 text-left">
        <b-table
          ref="table"
          id="my-table"
          :fields="fields"
          :busy.sync="isLoading"
          :items="myProvider"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
        >
          <template v-slot:cell(created_at)="data">{{age(data.item.created_at)}}</template>
          <template v-slot:cell(actions)="data">
            <font-awesome-icon
              v-b-tooltip.hover
              title="Edit Form"
              class="mr-2 text-primary"
              icon="edit"
            />

            <font-awesome-icon
              v-b-tooltip.hover
              title="Duplicate Form"
              class="mr-2 text-warning"
              icon="copy"
            />
            <font-awesome-icon
              :disabled="data.is_active == 0"
              v-b-tooltip.hover
              title="Delete Form"
              class="ml-2 text-danger"
              icon="trash"
            />
          </template>
        </b-table>
        <p class="mt-3">Current Page: {{ perPage }} rows</p>
        <b-row>
          <b-col cols="2">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination
              class="float-right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
// import { Helper } from "../../helpers";
import { HTTP } from "../../utils/HTTP";
import moment from "moment";
export default {
  name: "ClientProfileWorkTrainingCourses",
  components: {},
  data() {
    return {
      totalRows: 0,
      addTrainingCoursePath: "/add-training-courses/"+this.$route.params.id+"/",
      isLoading: false,
      filter: null,
      perPage: 5,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 100],
      fields: [
        { key: "id", label: "Id", sortable: true },
        { key: "created_at", label: "Age", sortable: false },
        { key: "company_id", label: "Client", sortable: false },
        { key: "courses_title", label: "Course Title", sortable: true },
        { key: "description", label: "Description", sortable: true },
        { key: "exam_id", label: "Exams", sortable: false },
        { key: "actions", label: "Actions", sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters({
      form: "form1"
    }),
    rows() {
      return this.totalRows;
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["setLanguage"]),
    ...mapMutations(["TOGGLE_LOADER"]),
    age(value) {
      let localeData = moment.updateLocale("en", {
        relativeTime: {
          future: "in %s",
          past: "%s ago",
          s: "hello, a few seconds",
          ss: "%d seconds",
          m: "a minute",
          mm: "%d minutes",
          h: "an hour",
          hh: "%d hours",
          d: "a day",
          dd: "%d days",
          M: "a month",
          MM: "%d months",
          y: "a year",
          yy: "%d years"
        }
      });
      return moment(value).fromNow();
    },
    async myProvider(ctx) {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage
      };

      this.isLoading = true;
      let token = "Bearer " + localStorage.getItem("accessToken");
      let result = HTTP("post", "v1/training/getallcourses", formData, {
        Authorization: token
      });

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    }
  }
};
</script>

<style>
</style>
